var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useMemo } from "react";
var useDataCards = function (setDataCards) {
    var setDataCardsList = useCallback(function (responseCertificates) {
        var dataCards = responseCertificates.map(function (item) { return (__assign(__assign({}, item), { id: item.id, title: item.title, type: item.type, physicalName: item.physicalName })); });
        setDataCards(dataCards);
    }, [setDataCards]);
    var optionsCards = useCallback(function (option, data, navigate, setCertificateName, setCertificateId, setOpenDeleteModal, setOpenDrawer, setHasProjectList, setPatchTrigger) {
        switch (option.id) {
            case "1": //Modificar certificado
                navigate("/certificates-editor/".concat(data.id, "/true"));
                sessionStorage.removeItem("hasShownToast");
                break;
            case "2": // Eliminar certificado
                setCertificateName(data.title || "");
                setCertificateId(data.id);
                setOpenDeleteModal(true);
                break;
            case "3": // asociar producto
                setCertificateId(data.id);
                setHasProjectList((data === null || data === void 0 ? void 0 : data.projects) || []);
                setOpenDrawer(true);
        }
    }, []);
    return useMemo(function () { return ({
        setDataCardsList: setDataCardsList,
        optionsCards: optionsCards,
    }); }, [setDataCardsList, optionsCards]);
};
export default useDataCards;
